import {Hamburger} from './Hamburger';
import {TabLoop} from './TabLoop';

export class Menu {

    private static menus:Menu[]=[];

    constructor(private menu:JQuery<HTMLElement>) {
        let existing=Menu.menus.find(x=>x.menu.is(menu));
        if (existing) return existing;
        menu.on('hamburger.open', ()=>this.open());
        menu.on('hamburger.close', ()=>this.close());
        menu.on('click', (ev)=>this.click(ev));
        menu.on('mouseleave', 'li.has-children', (ev) => this.changeSubmenu(ev));
        menu.on('mouseenter', 'ul', (ev) => this.enterSubmenu(ev));
        menu.on('mouseleave', 'ul', (ev) => this.leaveSubmenu(ev));
        $(window).on('breakrange',()=>this.breakrange());
        Menu.menus.push(this);
    }

    private css(prop:string,def:string,type:string='string',element:JQuery<HTMLElement>|null) {
        if (!element) element=this.menu;
        let r=element.css('--menu-'+prop);
        if (typeof r=='string') r=r.trim();
        if (r===undefined) r=def;
        if (type=='float') {
            if (r.match(/(%)$/)) return parseFloat(r)/100;
            return parseFloat(r);
        }
        if (type=='duration') {
            if (r.match(/(ms)$/)) return parseFloat(r);
            if (r.match(/(s)$/)) return parseFloat(r)*1000;
            return parseFloat(r);
        }
        if (type=='bool') {
            if (r=='false') return false;
            if (r=='true') return true;
            throw 'Invalid boolean property value for property "'+prop+'"';
        }
        return r;
    }

    private changeSubmenu(ev:JQuery.TriggeredEvent) {
        const ul = $(ev.currentTarget).closest('ul');
        ul.addClass('has-hover');
    }

    private enterSubmenu(ev:JQuery.MouseEnterEvent) {
        const ul = $(ev.currentTarget).closest('ul');
        if (!ul.parents('ul').length) this.menu.addClass('menu-hover');
    }

    private leaveSubmenu(ev:JQuery.MouseLeaveEvent) {
        if (ev.relatedTarget) {
            const related = $(ev.relatedTarget);
            if (related.closest(ev.currentTarget).length) return;
        }
        const ul = $(ev.currentTarget);
        ul.removeClass('has-hover');
        if (!ul.parents('ul').length) this.menu.removeClass('menu-hover');
    }

    private click(ev:JQuery.TriggeredEvent) {
        let target=$(ev.target);

        let atag=$(ev.target).closest('a');
        if (atag.length) {
            let link=(<HTMLAnchorElement>atag[0]);
            const isSamePage = (link.hostname === location.hostname) && (link.pathname === location.pathname) && link.hash !== '';
            if (isSamePage) new Hamburger($('.hamburger')).close();
            return;
        }

        let up=target.closest('button.menu-up');
        if (up.length) {
            let li=up.closest('li');
            this.closeSubmenu(li);
            return;
        }

        let button=target.closest('button.dropdown,button[role="menuitem"]');
        if (!button.length) return;
        let li=button.closest('li');

        if (!li.hasClass('open')) {
            // Already visible (e.g. via CSS :hover on desktop) → nothing to do
            if (this.getSubmenuFromListItem(li)[0]?.offsetHeight) return;

            let olis:JQuery<HTMLLIElement>=li.closest('ul').find('li.open');
            for (let oli of olis) this.closeSubmenu($(oli));
            this.openSubmenu(li);
        } else {
            this.closeSubmenu(li);
        }

    }

    private getSubmenuFromListItem(li:JQuery<HTMLLIElement>) {
        return li.find('.menu-sub').filter(function () {
            return $(this).parentsUntil(li, '.menu-sub').length === 0;
        });
    }

    private async openSubmenu(li:JQuery<HTMLLIElement>) {
        let submenu=this.getSubmenuFromListItem(li);
        li.addClass('opening');
        submenu.triggerHandler('menu.open');
        li.removeClass('opening').addClass('open');
    }

    private async closeSubmenu(li:JQuery<HTMLLIElement>) {
        let submenu=this.getSubmenuFromListItem(li);
        li.removeClass('open');
        submenu.triggerHandler('menu.close');
    }

    public breakrange() {
        this.menu.css('display','');
        this.menu.removeClass('open');
        new Hamburger($('.hamburger')).close();
    }

    public async open() {
        let open = this.menu.hasClass('open');
        if(open) return;
        this.menu.triggerHandler('menu.open');
        this.menu.addClass('open');
        new TabLoop(this.menu.parent());
    }

    private breakHover() {
        const subs=this.menu.find('li:not(.open)>.menu-sub');
        subs.css('display','none');
        requestAnimationFrame(()=>requestAnimationFrame(()=>subs.css('display','')));
    }

    public async close() {
        this.breakHover();
        let open = this.menu.hasClass('open');
        if(!open) return;
        new TabLoop(this.menu.parent()).destroy();
        this.menu.triggerHandler('menu.close');
        this.menu.removeClass('open');
    }

}

export {};